export const radioStyle = {
  display: 'block'
};

export const fractionType = {
  MONTHLY: 1,
  QUARTERLY: 3,
  BIANNUAL: 6,
  YEARLY: 12
};

export const indicators = [
  'transformationRate',
  'unpaidRate',
  'incompleteFiles',
  'claimsRate'
];

export const daysOfWeek = [
  'monday',
  'tuesday',
  'wednesday',
  'thursday',
  'friday',
  'saturday'
];
